import { render, staticRenderFns } from "./CoachListHome.vue?vue&type=template&id=6c6a65ec&scoped=true&"
import script from "./CoachListHome.vue?vue&type=script&lang=js&"
export * from "./CoachListHome.vue?vue&type=script&lang=js&"
import style0 from "./CoachListHome.vue?vue&type=style&index=0&id=6c6a65ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a65ec",
  null
  
)

export default component.exports